/**
 * App component.
 */

// Styles
import '@shared/assets/style/animation.less';
import '@shared/assets/style/global.less';

// Components before viewless is better
import Ads from '@components/elements/adsPlayer/adsSelector';
import FloatingMenu from '@components/sections/floatingMenu/floatingMenu';
import Modal from '@shared/components/utils/modals/modalManager';
import Network from '@components/sections/network/network';
import Router from '@shared/components/utils/router/router';
import Splash from '@components/sections/splash/splash';
import Dial from '@components/elements/dial/dial';

// Viewless after components is better
import Global from './global';

/**
 * Main application component.
 * Renders all top-level components including router, menu, modals, floating menu, dial, ads, splash, network, and global viewless components.
 *
 * @returns {JSX.Element} The complete application structure
 */
export default function App() {
  return (
    <>
      {/* Visible components */}
      <Splash />
      <Ads />
      <Router />
      <Modal />
      <FloatingMenu />
      <Dial />
      <Network />
      {/* Viewless components */}
      <Global />
    </>
  );
}
